import TermsAndCondition from '@/kyna/view/_public/TermsAndCondition';
import BaseTemplate from '../src/layouts/BaseTemplate'

const Terms_And_Condition = () => {
    return ( 
        <BaseTemplate title="Terms and Condition" body={<TermsAndCondition/>} />
     );
}
 
export default Terms_And_Condition;